"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const directives_1 = require("../directives");
const getObjectTypes_1 = __importDefault(require("../getObjectTypes"));
const addObjectFilters_1 = require("./addObjectFilters");
const addObjectOrderBy_1 = require("./addObjectOrderBy");
exports.default = (composer) => {
    const contentTypes = getObjectTypes_1.default(composer);
    composer.createEnumTC(`
    enum VLOrderBy {
      asc
      desc
    }
  `);
    contentTypes.forEach(type => {
        const rootField = directives_1.getRootQueryField(type);
        if (rootField) {
            const typename = type.getTypeName();
            composer.Query.addFields({
                [rootField]: `[${typename}!]!`,
            });
            composer.Query.addFieldArgs(rootField, {
                where: addObjectFilters_1.getTypeFilterName(typename),
                orderBy: addObjectOrderBy_1.getTypeOrderByName(typename),
                limit: `Int`,
                offset: `Int`,
            });
        }
    });
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYWRkUm9vdFF1ZXJpZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY21zL3NjaGVtYS9idWlsZGVycy9hZGRSb290UXVlcmllcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7OztBQUNBLDhDQUFrRDtBQUNsRCx1RUFBK0M7QUFDL0MseURBQXVEO0FBQ3ZELHlEQUF3RDtBQUV4RCxrQkFBZSxDQUFDLFFBQTZCLEVBQUUsRUFBRTtJQUMvQyxNQUFNLFlBQVksR0FBRyx3QkFBYyxDQUFDLFFBQVEsQ0FBQyxDQUFDO0lBQzlDLFFBQVEsQ0FBQyxZQUFZLENBQUM7Ozs7O0dBS3JCLENBQUMsQ0FBQztJQUNILFlBQVksQ0FBQyxPQUFPLENBQUMsSUFBSSxDQUFDLEVBQUU7UUFDMUIsTUFBTSxTQUFTLEdBQUcsOEJBQWlCLENBQUMsSUFBSSxDQUFDLENBQUM7UUFDMUMsSUFBSSxTQUFTLEVBQUU7WUFDYixNQUFNLFFBQVEsR0FBRyxJQUFJLENBQUMsV0FBVyxFQUFFLENBQUM7WUFDcEMsUUFBUSxDQUFDLEtBQUssQ0FBQyxTQUFTLENBQUM7Z0JBQ3ZCLENBQUMsU0FBUyxDQUFDLEVBQUUsSUFBSSxRQUFRLEtBQUs7YUFDL0IsQ0FBQyxDQUFDO1lBQ0gsUUFBUSxDQUFDLEtBQUssQ0FBQyxZQUFZLENBQUMsU0FBUyxFQUFFO2dCQUNyQyxLQUFLLEVBQUUsb0NBQWlCLENBQUMsUUFBUSxDQUFDO2dCQUNsQyxPQUFPLEVBQUUscUNBQWtCLENBQUMsUUFBUSxDQUFDO2dCQUNyQyxLQUFLLEVBQUUsS0FBSztnQkFDWixNQUFNLEVBQUUsS0FBSzthQUNkLENBQUMsQ0FBQztTQUNKO0lBQ0gsQ0FBQyxDQUFDLENBQUM7QUFDTCxDQUFDLENBQUMifQ==